import { map } from 'lodash'
import moment from 'moment'
import { error } from '@/utils/alert'

const prepareShow = parking => {
  parking.date_go_in = moment(parking.date_go_in, 'YYYYMMDD').format('YYYY-MM-DD')
  parking.date_go_out = moment(parking.date_go_out, 'YYYYMMDD').format('YYYY-MM-DD')
  parking._edit_date_go_in = moment(parking.date_go_in, 'YYYYMMDD').format('DD/MM/YYYY')
  parking._edit_date_go_out = moment(parking.date_go_out, 'YYYYMMDD').format('DD/MM/YYYY')
  return parking
}

const prepareSave = parking => {
  const isAfter = moment(parking.date_go_out).isAfter(parking.date_go_in)

  if (!isAfter) {
    error('A data final precisa se maior que a data inicial')
    parking.date_go_out = null
    return parking
  }
  return parking
}

export default {
  prepareSave,
  prepareShow,
  validityDate (dt) {
    const isAfter = moment(this.parking.date_go_out).isAfter(this.parking.date_go_in)

    if (!isAfter) {
      this.$toast.error('A data final precisa se maior que a data inicial.')
      this.parking.date_go_out = null
    }
  },
  afterCreated () {
    this.$toast.success('Empréstimo incluido com sucesso.')
    return this.$router.push({name: 'tenant.parking.index'})
  },
  afterUpdated () {
    this.$toast.success('Empréstimo alterado com sucesso.')
    return this.$router.push({name: 'tenant.parking.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }
  },
  getGaragesDweller (unit) {
    if (typeof unit === 'object') {
      const search = {
        unit_id: unit.id,
        tower_id: this.parking.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: this.parking.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getGaragesDwellerEdit (unit, tower) {
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: tower
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getUnits (id) {
    const params = {
      id: id
    }
    this.$http.post('/v1/dweller/search/all', params)
      .then((data) => {
        this.optionUnits = data.data
      })
  },
  getTowers () {
    this.$http.get('/v1/dweller/search/tower')
      .then((data) => {
        this.optionTowers = data.data
        if (this.optionTowers.length >= 1) {
          this.getUnits(this.optionTowers[0].id)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/parking/form/resources/methods.js